import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import ConnectedFormControl from '../FormControl/FormControl.js';
import { isEmailAddress } from '../Util/validations.js';

const Email = (_param)=> {
    var { id ='email' , 'data-t': dataT = 'email' , label , errorMessage , validations =[
        isEmailAddress
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        'data-t',
        "label",
        "errorMessage",
        "validations"
    ]);
    return React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
        id: id,
        "data-t": dataT,
        type: "email",
        label: label,
        errorMessage: errorMessage,
        validations: validations
    }, rest));
};

export { Email as default };
//# sourceMappingURL=Email.js.map
